<template>
  <div class="bq-solutions-wjw">
    <div class="bq-solutions-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-solutions-title-wrap" :class="animateTitle">
          <div
            class="bq-solutions-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <div class="bq-solutions-subtitle">
            居民电子健康卡/互联网医院平台/处方交换及监管中心
          </div>
        </div>
      </div>
    </div>
    <BqTab :tabs="tabs" :activeIndex="activeIndex" @handleClick="handleClick">
      <div class="bq-solution-item card" slot="card">
        <SectionTitle :title="'居民电子健康卡'"></SectionTitle>
        <p class="tl w1200">
          浙江省居民电子健康卡是浙江省卫生健康委员会按照国家统一标准，方便在我省医疗机构就诊的人群，实现跨机构和跨地域的线上线下一体化医疗健康
          服务而提供的电子卡
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB16ZyTC7Y2gK0jSZFgXXc5OFXa-861-166.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1Fwm1C8r0gK0jSZFnXXbRRXXa-1197-393.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
      <div class="bq-solution-item plat" slot="plat">
        <SectionTitle :title="'互联网医院平台'"></SectionTitle>
        <div class="bq-solution-tag">集监管与服务为一体的互联网诊疗总入口</div>
        <div class="bq-item-title">浙江省互联网医院平台</div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1wa2fC1H2gK0jSZFEXXcqMpXa-1034-288.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'服务子平台'"></SectionTitle>
        <p>
          以患者为中心，支付宝搜索“浙江省互联网医院平台”使用在线咨询、在线复诊、电子处方、居家护理等服务。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1RyYhCVP7gK0jSZFjXXc5aXXa-594-478.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'监管子平台'"></SectionTitle>
        <p>
          通过数据接入对所有提供互联网诊疗服务的医疗机构进行实时监管，包括事前、事中、事后监管，保障医疗质量，规避医疗风险。
        </p>
      </div>
      <div class="bq-solution-item prec" slot="prec">
        <SectionTitle :title="'浙江省处方交换及监管中心'"></SectionTitle>
        <p>
          接入省内医院线上及线下处方，
          搭建浙江省处方共享交换中心，实现省内处方统一监管。同时基于处方共享交换中心，实现省内电子处方的统一流转。
        </p>
        <div class="bq-item-title">浙江省处方交换及监管中心</div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1JpnrC.T1gK0jSZFhXXaAtVXa-826-462.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
    </BqTab>
  </div>
</template>
<script>
import BqTab from '@/components/website_v3/Tab';
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'wjw',

  data() {
    return {
      animateTitle: [],
      titlebg:
        'https://img.alicdn.com/tfs/TB1eJScGXT7gK0jSZFpXXaTkpXa-1162-428.png',
      cover:
        'https://img.alicdn.com/tfs/TB1AQ.rgsKfxu4jSZPfXXb3dXXa-1920-380.png',
      activeIndex: parseInt(this.$route.query.tab || '0'),
      tabs: [
        {
          title: '居民电子健康卡',
          slot: 'card',
        },
        {
          title: '互联网医院平台',
          slot: 'plat',
        },
        {
          title: '处方交换及监管中心',
          slot: 'prec',
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  components: {
    BqTab,
    SectionTitle,
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';

.bq-solutions-wjw {
  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }

  .tl {
    text-align: left !important;
  }

  .bq-solutions-banner {
    position: relative;
    width: 100%;
    height: 380px;
    overflow: hidden;
    color: #fff;

    .bq-banner-cover {
      width: 100%;
      height: 100%;
      .bgNoImg();
      position: relative;

      .bq-solutions-title-wrap {
        margin: 0 auto;
        position: absolute;
        top: 40px;
        right: 48%;
        transform: translateX(50%);
        &.animate-title {
          .bq-solutions-title {
            animation: bounce 1s linear;

            @keyframes bounce {
              0% {
                opacity: 0;
                transform: translate3d(0, 200%, 0);
              }

              60% {
                transform: translate3d(0, -30px, 0);
              }

              80% {
                transform: translate3d(0, -10px, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }

          .bq-solutions-subtitle {
            transform: translate3d(0, 0, 0);
            opacity: 1;
            animation: leftslide 1s ease;

            @keyframes leftslide {
              0% {
                opacity: 0;
                transform: translate3d(500%, 0, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }
        }
      }

      .bq-solutions-title {
        margin: 0 auto;
        width: 645px;
        height: 233px;
        margin-bottom: 22px;
        background-size: cover;
      }
      .bq-solutions-subtitle {
        opacity: 0;
        width: 700px;
        margin: 0 auto;
        text-align: center;
        font-size: 18px;
        letter-spacing: 10px;
      }
    }
  }

  .bq-solution-item {
    text-align: center;
    p {
      text-align: center;
      color: #333;
      font-size: 18px;
      margin-bottom: 60px;
    }

    & > div {
      margin-bottom: 60px;
    }

    .bq-solution-tag {
      margin: 0 auto;
      width: 363px;
      height: 60px;
      line-height: 60px;
      color: #fff;
      font-size: 18px;
      background: rgba(32, 93, 171, 1);
      border-radius: 6px;
      cursor: default;
    }

    .bq-item-title {
      margin-top: 60px;
      margin-bottom: 0;
      color: #205dab;
      font-size: 24px;
    }
  }
}
</style>
